import React from "react";
import { getAmount } from "../../../../utils/helper";
import MiniSparkline from "./MiniSparkline";
import { DashAnalyticsTrendCardSkeleton } from "./DashCardSkeletons";

function formatTrendPct(pct) {
  if (pct == null || Number.isNaN(pct)) return "—";
  const abs = Math.abs(pct);
  const arrow = pct > 0 ? "↑" : pct < 0 ? "↓" : "→";
  return `${arrow}${abs}%`;
}

/**
 * KPI card with sparkline + half-range trend (Metronic-friendly).
 */
export default function DashAnalyticsTrendCard({
  title,
  value,
  subtitle,
  trend,
  currencySign = "₹",
  sparklineData = [],
  sparkColor = "#50cd89",
  invertTrendColors = false,
  loading = false,
  accentClass = "",
}) {
  const pct = trend?.pct;
  const upGood = !invertTrendColors;
  const trendUp = pct != null && pct > 0;
  const trendDown = pct != null && pct < 0;
  const trendFlat = pct != null && pct === 0;

  let trendClass = "text-gray-500";
  if (!trendFlat && pct != null) {
    const good = (trendUp && upGood) || (trendDown && !upGood);
    const bad = (trendUp && !upGood) || (trendDown && upGood);
    if (good) trendClass = "text-success";
    else if (bad) trendClass = "text-danger";
  }

  const showSpark = !loading && sparklineData.length > 1;

  return (
    <div className={`card border border-gray-200 shadow-none h-100 dash-analytics-trend-card ${accentClass}`}>
      <div className="card-body p-4 p-lg-5 d-flex flex-column">
        <div className="text-gray-600 fw-semibold fs-7 text-uppercase mb-3">{title}</div>
        {loading ? (
          <DashAnalyticsTrendCardSkeleton showSpark />
        ) : (
          <div className="d-flex flex-wrap align-items-start justify-content-between gap-3">
            <div className="flex-grow-1" style={{ minWidth: 0 }}>
              <div className="fs-2 fw-bolder text-gray-900 lh-1 mb-2">{value}</div>
              {subtitle ? <div className="fs-7 fw-semibold text-gray-700 mb-2">{subtitle}</div> : null}
              {pct != null ? (
                <div className={`fs-8 fw-bold ${trendClass} d-flex flex-wrap align-items-baseline gap-2`}>
                  {trend?.delta != null ? (
                    <span className="text-gray-800">{getAmount(trend.delta, currencySign)}</span>
                  ) : null}
                  <span>{formatTrendPct(pct)}</span>
                  <span className="text-muted fw-normal fs-8">vs period</span>
                </div>
              ) : null}
            </div>
            {showSpark ? (
              <div
                className="dash-analytics-trend-card__spark flex-shrink-0 d-none d-lg-block"
                style={{ width: "min(160px, 30%)", alignItems: "center" }}
              >
                <MiniSparkline data={sparklineData} color={sparkColor} height={52} />
              </div>
            ) : null}
          </div>
        )}
      </div>
    </div>
  );
}
